import gql from "graphql-tag";

export default gql`
	query getSerialNumberByCode($serialNumber: String!) {
		getSerialNumberByCode(serialNumber: $serialNumber) {
			licenseName
			serialNumber
			isBeta
			isDeveloper
			expirationDate
			supportExpirationDate
			plan {
				planCode
			}
			subscriptionID
			downloads {
				id
				os
				release
				releaseDate
				architectures
				minOSVersion
				minOSName
				downloadLink
			}
		}
	}
`;

export const readSerialNumberByCode = ({ data }) => data && data.getSerialNumberByCode;
